import { render } from "./notification.vue?vue&type=template&id=e6383cbe&scoped=true"
import script from "./notification.vue?vue&type=script&lang=js"
export * from "./notification.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e6383cbe"

export default script